module.exports = __webpack_public_path__ + "img/loader.322d90db.gif";